import { getJobApiCall, postJobApiCall } from "../../utils/jobRequest";
import { handle403Logout } from "../../utils/request";
import { SET_DASHBOARD_CHART_DATA, SET_DASHBOARD_SUMMARY, SET_DASHBOARD_TOP_JOBS, SET_JOB_LIST, SET_NOTIFICATIONS } from "../Types/types";
import { returnErrors } from "./errorAction";

//dashboard charts
export const getDashboardChartData = (obj) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`event-metrics/chart`, obj);
    if (response?.status === 200) {
      dispatch({type: SET_DASHBOARD_CHART_DATA ,payload: response.data});
      return response.data;
    } else {
      returnErrors(dispatch,response?.data?.responseMessages[0]?.message,response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages[0]?.message,error?.response?.status);
  }
};

//dashboard summary
export const getDashboardSummary = (obj) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`event-metrics/summary`, obj);
    if (response?.status === 200) {
      dispatch({type: SET_DASHBOARD_SUMMARY ,payload: response.data});
      return response.data;
    } else {
      returnErrors(dispatch,response?.data?.responseMessages[0]?.message,response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages[0]?.message,error?.response?.status);
  }
};

//dashboard summary
export const getDashboardTopJobs = (obj, categoryKey) => async (dispatch) => {
  try {
    const response = await postJobApiCall(`event-metrics/top-jobs`, obj);
    if (response?.status === 200) {
      dispatch({ type: SET_DASHBOARD_TOP_JOBS, payload: {data: response.data, __category: categoryKey} });
      return response.data;
    } else {
      returnErrors(dispatch,response?.data?.responseMessages[0]?.message,response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages[0]?.message,error?.response?.status);
  }
};

//list jobs
export const getJobList = () => async (dispatch) => {
  try {
    const response = await getJobApiCall(`event-metrics/jobs`);
    if (response?.status === 200) {
      dispatch({type: SET_JOB_LIST ,payload: response.data});
      return response.data;
    } else {
      returnErrors(dispatch,response?.data?.responseMessages[0]?.message,response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages[0]?.message,error?.response?.status);
  }
}

// notifications live feed
export const getLatestNotifications = (query = {}) => async (dispatch) => {
  try {
    const queryParams = new URLSearchParams(query).toString();
    const url = `notifications/${queryParams ? "?" + queryParams : ""}`;
    const response = await getJobApiCall(url);
    if (response?.status === 200) {
      dispatch({ type: SET_NOTIFICATIONS, payload: response.data });
    } else {
      returnErrors(dispatch, response?.data?.responseMessages?.[0]?.message, response?.status);
    }
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch,error.response?.data?.responseMessages[0]?.message,error?.response?.status);
  }
}